import React from 'react';
import { Bot } from 'lucide-react';
import { CommentArtifactChat } from './CommentArtifactChat';

export interface ChatSectionProps {
  docketNumber: string;
}

/**
 * Proceedings-page chat section.
 *
 * Wraps the new CommentArtifactChat (typed-artifact-backed) which
 * replaces the old free-form RAG chat. Built for attorneys drafting
 * client comments — fast lookups, in-depth analysis, verifiable
 * citations.
 *
 * Architecture: ByteRover commsgenie space →
 *   architecture/comment_analysis/comment_analysis_artifact_architecture.md
 */
export const ChatSection: React.FC<ChatSectionProps> = ({ docketNumber }) => {
  return (
    <div className="backdrop-blur-xl bg-white/90 border border-blue-300/50 rounded-lg p-6 shadow-sm mb-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-3 rounded-xl bg-gradient-to-r from-blue-500/20 to-purple-500/20 backdrop-blur-sm border border-blue-200/30">
          <Bot className="w-6 h-6 text-blue-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Comment Analysis Chat</h2>
          <p className="text-gray-600 text-sm">
            Ask questions about positions, filers, arguments, and authorities.
            Built for drafting your client's comment.
          </p>
        </div>
      </div>

      <CommentArtifactChat docketNumber={docketNumber} />
    </div>
  );
};
